export interface SEOMetaProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  publishedTime?: string;
  modifiedTime?: string;
  author?: string;
}

export default function SEOMeta({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogImage,
  publishedTime,
  modifiedTime,
  author,
}: SEOMetaProps) {
  const fullTitle = `${title} - 韩漫漫画网`;

  document.title = fullTitle;

  const setMeta = (name: string, content: string, property = false) => {
    const attr = property ? 'property' : 'name';
    let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute(attr, name);
      document.head.appendChild(el);
    }
    el.setAttribute('content', content);
  };

  const setLink = (rel: string, href: string) => {
    let el = document.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement | null;
    if (!el) {
      el = document.createElement('link');
      el.setAttribute('rel', rel);
      document.head.appendChild(el);
    }
    el.setAttribute('href', href);
  };

  setMeta('description', description);
  if (keywords) setMeta('keywords', keywords);
  setLink('canonical', canonicalUrl);

  setMeta('og:title', fullTitle, true);
  setMeta('og:description', description, true);
  setMeta('og:type', ogType, true);
  setMeta('og:url', canonicalUrl, true);
  setMeta('og:site_name', '韩漫漫画网', true);
  setMeta('og:locale', 'zh_CN', true);
  if (ogImage) setMeta('og:image', ogImage, true);

  setMeta('twitter:card', 'summary_large_image');
  setMeta('twitter:title', fullTitle);
  setMeta('twitter:description', description);
  if (ogImage) setMeta('twitter:image', ogImage);

  if (publishedTime) setMeta('article:published_time', publishedTime, true);
  if (modifiedTime) setMeta('article:modified_time', modifiedTime, true);
  if (author) setMeta('article:author', author, true);

  if (publishedTime) setMeta('last-modified', modifiedTime || publishedTime);

  return null;
}